import(/* webpackMode: "eager" */ "/home/ubuntu/download/699cb5e1f782d500143c160f/templatemarketplace/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699cb5e1f782d500143c160f/templatemarketplace/src/app/template-detail/components/TemplateDetailClient.tsx");
